import PublicRoutes from './PublicRoutes';
import AdminRoutes from "./AdminRoutes";
import { MenuItemKey } from '../../Layout/Sidebar/MenuItemKey';

export const routes: IRoute<any>[] = [
    ...new PublicRoutes().routes,
    ...new AdminRoutes().routes,
];

export interface IRoute<TProps>
{
    isPublic?: boolean;
    requiredRights: string[];
    path: string;
    props?: TProps;
    legacyPaths?: ILegacyRoute[];
    component: React.ComponentType<TProps>;
    menuItemId?: MenuItemKey;
}

export interface ILegacyRoute
{
    path: string;
    parameterMap?: IRouteParameterMap;
}

export interface IRouteParameterMap
{
    [oldName: string]: string;
}
